import { usePendingSectorsCountQuery } from '../../services/totem-sector.service';

const usePendingSectorsCount = () => {
  const { data: pendingSectorsCount, isLoading } = usePendingSectorsCountQuery(
    undefined,
    { pollingInterval: 2000 }
  );

  return {
    pendingSectorsCount: pendingSectorsCount,
    isLoading,
  };
};

export default usePendingSectorsCount;
